import { Form } from 'antd';
import { type DisplayFieldWithUTCOffsetProps } from '../../../components/fields/DisplayFieldWithUTCOffset';
import { StyledTextFieldWrapper } from './shared';

const DisplayFieldWithUTCOffset = (props: DisplayFieldWithUTCOffsetProps) => {
    const { label, value, disabled, offset } = props;
    const labelUTC = offset ? `${label} (UTC${offset})` : label;

    if (typeof value === 'string' || typeof value === 'number') {
        return (
            <Form.Item>
                <StyledTextFieldWrapper>
                    {label && <span slot="label">{labelUTC}</span>}
                    <input disabled={disabled} type="text" value={value} readOnly />
                </StyledTextFieldWrapper>
            </Form.Item>
        );
    }

    return (
        <Form.Item>
            <StyledTextFieldWrapper>
                {label && <span slot="label">{labelUTC}</span>}
                <input disabled={disabled} type="text" readOnly />
            </StyledTextFieldWrapper>
        </Form.Item>
    );
};

export default DisplayFieldWithUTCOffset;
